<template>
  <RouterView />
  <Toast />
</template>

<script setup lang="ts">
import Toast from 'primevue/toast';
</script>
